export const hasActiveFilter = (filterChoices) => Object.values(filterChoices).some((items) => items.some(({ isSelected }) => isSelected));
export const extractSelected = (filterChoices, key) => filterChoices[key]
    .filter(({ isSelected }) => isSelected)
    .map(({ key }) => key);
